import { render, staticRenderFns } from "./VideoPreview.vue?vue&type=template&id=ce647cb6&scoped=true&"
import script from "./VideoPreview.vue?vue&type=script&lang=js&"
export * from "./VideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./VideoPreview.vue?vue&type=style&index=0&id=ce647cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce647cb6",
  null
  
)

export default component.exports